<template>
  <div v-if="item">
    <div v-if="item.order">
      <h5>Номер заказа: # {{ item.order.id }}</h5>
      <h5>
        Покупатель: {{ item.order.client.last_name }}
        {{ item.order.client.first_name }}
      </h5>
      <h5>Контактный номер покупателя: {{ item.order.client.phone }}</h5>
    </div>
    <div v-if="item.service">
      <h4>Сервис: {{ item.service.name }}</h4>
      <p class="text-info text-right">Код сервиса: {{ item.service.code }}</p>
    </div>
    <div v-if="item.model">
      <component :is="`flow-${item.model_type}`" :id="item.model_id" />
    </div>
    <div v-else>
      <component
        :params="{}"
        :is="`create-${item.service.code}`"
        :data="item"
        @input="getItem"
      />
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

import CreateKeeptok from "@/components/Services/_create/CreateKeeptalk.vue";
import CreateTradeIn from "@/components/Services/_create/CreateTradeIn.vue";

export default {
  components: { CreateKeeptok, CreateTradeIn },
  data: () => ({
    cardLink: "order_services",
    cardSetLink: "order_services",
    item: null,
    fields: [],
  }),
  props: ["id"],
  async created() {
    this.getItem();
  },
  methods: {
    async getItem() {
      this.item = await this.cardContent(this.cardLink, this.id);
    },
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
